export default "__VITE_ASSET__AYfT_9Uc__"